/**
 * 全局域名配置
 */

export type TMedia = 'mobile' | 'pc';

interface IServerRpcClientConnections {
    officialSiteDataCache: string;
    webProductApiProxy: string;
}

class Config {

    public apiVersion = 'v2';

    public screen: TMedia = 'pc';

    public rpcCache = ENV_CONFIG.rpcCache;

    public dealsCache = ENV_CONFIG.dealsCache;

    public site: string = ENV_CONFIG.REO_MERCHANT;

    public rmaApi: string = ENV_CONFIG.rmaApi;
    
    public api: string = ENV_CONFIG.api;

    public adminApi: string = ENV_CONFIG.adminApi;

    public store: string = ENV_CONFIG.store;

    public cloud: string = ENV_CONFIG.cloud;

    public account: string = ENV_CONFIG.account;

    public liveSSE: string = ENV_CONFIG.liveSSE;

    public official: string = ENV_CONFIG.official;

    public eztechKey: string = ENV_CONFIG.eztechKey;

    public cdnDomain: string = ENV_CONFIG.cdnDomain;

    public clientId: string = ENV_CONFIG.clientId ?? '';

    public accountCenterClientId: string = ENV_CONFIG.accountCenterClientId ?? '';

    public cookieDomain: string = ENV_CONFIG.cookieDomain;

    public supportDomain: string = ENV_CONFIG.supportDomain;

    public supportOrdersTicket: string = ENV_CONFIG.supportOrdersTicket;

    public supportTechnicalTicket: string = ENV_CONFIG.supportTechnicalTicket;

    public supportWarrantyTicket: string = ENV_CONFIG.supportWarrantyTicket;

    public constructor() {

        if (typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('mobile')) {

            this.screen = 'mobile';
        }

        if (__BUILD_MODE__ === 'lib') {
            if (typeof process !== 'undefined' && process?.env) {
                const SERVER_CONNECTIONS_BASED_KEY = 'RPC_CLIENT_CONNECTIONS';
                const SERVER_CONNECTIONS_KEYS: Array<keyof IServerRpcClientConnections> = ['officialSiteDataCache', 'webProductApiProxy'];
                const connections: Partial<IServerRpcClientConnections> = {};
                for (const key of SERVER_CONNECTIONS_KEYS) {
                    const rpcClientConnection =  process.env[`${SERVER_CONNECTIONS_BASED_KEY}_${key}`];
                    if (rpcClientConnection) {
                        connections[key] = rpcClientConnection;
                    }
                }
                if (connections.officialSiteDataCache) {
                    this.rpcCache = connections.officialSiteDataCache;
                }
                if (connections.webProductApiProxy) {
                    this.dealsCache = connections.webProductApiProxy;
                }
            }
        }
    }

}

export default new Config();
